import { Directive, ElementRef, AfterViewInit, OnDestroy, Input } from '@angular/core';

@Directive({
  selector: '[appAnimateOnScroll]',
  standalone: true
})
export class AnimateOnScrollDirective implements AfterViewInit, OnDestroy {
  @Input('appAnimateOnScroll') animationClass = 'fade-in';
  @Input() rootMargin = '0px';
  @Input() threshold = 0.2;

  private observer: IntersectionObserver | undefined;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.el.nativeElement.classList.add('animation-hidden'); // Hide element initially
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.el.nativeElement.classList.add(this.animationClass);
          this.observer?.unobserve(this.el.nativeElement);
        }
      });
    }, {
      rootMargin: this.rootMargin,
      threshold: this.threshold
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
} 